<template>
  <v-container class="fill-height">
    <v-row v-if="floorContent">
      <v-col md="10" offset-md="1">
        <v-alert type="success" v-if="success">
          Floor successfully created
        </v-alert>
        <v-alert type="error" v-if="error">
          Something went wrong. Please check the developer console!
        </v-alert>
        <v-tabs v-model="languageTab" background-color="transparent">
          <v-tab v-for="language in languages" :key="language.code" :href="'#' + language.code">
            {{ language.name }}
          </v-tab>
        </v-tabs>
        <v-form @submit.prevent="handleSubmit" id="building-create-form" class="building-create-form" ref="form" v-model="isValid">
          <div v-for="language in languages" :key="language.code" v-show="language.code === languageTab">
            <v-row>
              <v-col md="6">
                <v-autocomplete item-text="name" item-value="value" v-model="selectedEntrance" prepend-icon="mdi-office-building" label="Изберете вход" :items="autocompleteBuildingsEntrances" :rules="[rules.required]" required>
                  <template v-slot:selection="data">
                    {{ data.item.name }}
                  </template>
                  <template v-slot:item="data">
                    <template>
                        <v-list-item-content>
                          <v-list-item-title v-html="data.item.name"></v-list-item-title>
                          <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6">
                <v-text-field name="title" prepend-icon="mdi-pencil" label="Заглавие" v-model="floorContent[language.code].title" :rules="[rules.required]" required></v-text-field>
              </v-col>
              <v-col md="6">
                <v-file-input
                  accept="image/png, image/jpeg, image/bmp"
                  prepend-icon="mdi-file-image"
                  label="Изображение"
                  v-model="image"
                ></v-file-input>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="12">
                <v-textarea prepend-icon="mdi-map-marker-path" v-model="coordinates" name="coordinates" label="Координати"></v-textarea>
              </v-col>
            </v-row>
            <v-expansion-panels v-model="seoPanel" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>SEO</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col md="6">
                      <v-text-field name="slug" prepend-icon="mdi-pencil" label="Слъг" v-model="floorContent[language.code].slug" :rules="[rules.required]" required></v-text-field>
                    </v-col>
                    <v-col md="6">
                      <v-text-field name="seo_title" prepend-icon="mdi-pencil" label="Заглавие" v-model="floorContent[language.code].seoTitle"></v-text-field>
                    </v-col>
                    <v-col md="12">
                      <v-text-field name="seo_description" prepend-icon="mdi-pencil" label="Описание" v-model="floorContent[language.code].seoDescription"></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-row>
              <v-col md="3">
                <v-switch value input-value="true" label="Активен в сайта" color="indigo" v-model="isActive"></v-switch>
              </v-col>
            </v-row>
          </div>
        </v-form>
        <v-btn color="success" type="submit" form="building-create-form">Запиши</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { uploadImage } from '@/repositories/upload.repository'
import { updateFloor } from '@/repositories/floor.repository'
export default {
  data () {
    return {
      isValid: false,
      selectedEntrance: null,
      title: null,
      image: null,
      coordinates: null,
      slug: null,
      seoTitle: null,
      seoDescription: null,
      isActive: true,
      seoPanel: [0],
      success: false,
      error: false,
      languageTab: null,
      floorContent: null,
      rules: {
        required: value => !!value || 'Това поле е задължително!'
      }
    }
  },
  created () {
    this.$store.dispatch('fetchLanguages')
      .then(() => {
        this.floorContent = {};
        for (const language of this.languages) {
          this.floorContent[language.code] = {
            title: null,
            seoTitle: null,
            seoDescription: null,
            slug: null
          };
        }

        this.$store.dispatch('fetchFloor', this.$route.params.id)
      })

    this.$store.dispatch('fetchBuildingsEntrances')
  },
  computed: {
    floor () {
      return this.$store.state.floor.floor
    },
    languages () {
      return this.$store.state.language.languages
    },
    buildingsEntrances () {
      return this.$store.state.building.buildingsEntrances
    },
    autocompleteBuildingsEntrances () {
      const buildingsEntrances = [...this.buildingsEntrances]

      let result = []
      for (let building of buildingsEntrances) {
        result.push({ header: building.translations.title })
        for (let entrance of building.entrances) {
          result.push({ name: entrance.translations.title, group: building.translations.title, value: { entrance: entrance.id, building: building.id } })
        }
        result.push({ divider: true })
      }

      result.pop();
      return result
    }
  },
  watch: {
    floor (floor) {
      if (floor) {
          this.setFloorValues()
      }
    }
  },
  methods: {
    setFloorValues () {
      this.selectedEntrance = {
        entrance: this.floor.entranceId,
        building: this.floor.buildingId
      }

      this.coordinates = this.floor.coordinates
      this.isActive = this.floor.active

      const floorTranslations = this.floorContent[this.languageTab]
      this.floor.translations.seoDescription && (floorTranslations.seoDescription = this.floor.translations.seoDescription)
      this.floor.translations.seoTitle && (floorTranslations.seoTitle = this.floor.translations.seoTitle)
      this.floor.translations.slug && (floorTranslations.slug = this.floor.translations.slug)
      this.floor.translations.title && (floorTranslations.title = this.floor.translations.title)
    },
    handleSubmit () {
      this.$refs.form.validate()
      if (!this.isValid) {
        return
      }

      if (!this.image) {
        this.createFloor()
        this.scrollToTop()
        return
      }

      this.uploadImage()
      this.scrollToTop()
    },
    uploadImage () {
      const formData = new FormData()
      formData.append('file', this.image)

      try {
        uploadImage(formData)
          .then(res => {
            this.createFloor(res.data.file)
          }).catch(error => {
            console.log(error)
            this.error = true
            this.success = false
          })
      } catch (e) {
        console.log(e)
        this.error = true
        this.success = false
      }
    },
    createFloor (image = null) {
      const floor = {
        coordinates: this.coordinates,
        active: this.isActive,
        image,
        entranceId: this.selectedEntrance.entrance,
        buildingId: this.selectedEntrance.building,
        ...this.floorContent
      }

      try {
        updateFloor(this.$route.params.id, floor)
          .then(response => {
            const { success } = response.data
            this.success = success
            this.error = !this.success

            this.reset()
          }).catch(error => {
            console.log(error)
            this.error = true
            this.success = false
          })
      } catch (e) {
        console.log(e)
        this.error = true
        this.success = false
      }
    },
    scrollToTop () {
      window.scroll({
        top: 0,
        behavior: 'smooth'
      })
    },
    reset () {
      this.$refs.form.reset()
    }
  }
}
</script>

<style lang="scss">
.change-building-link {
  font-size: 0.875rem;
  text-decoration: none;
}
.building-autocomplete {
  .v-input__append-outer {
    pointer-events: initial;
    position: absolute;
    right: 30px;
    z-index: 999;
    cursor: pointer;
  }
}
</style>